<template>
  <div>
    <div id="header-container" class="pl-5">
      <img :src="`${publicPath}/img/gep/bg-header.svg`" class="img-header" />
      <div class="pt-4 text-white">
        <h3 class="text-white">{{ $t("Accounts") }}</h3>
        <span class="fz-16 fw-400">{{
          $t("Manage and access all your accounts here")
        }}</span>
      </div>
    </div>

    <b-container fluid class="mt-0 pb-5">
      <div id="body-container">
        <b-row>
          <b-col xl="12">
            <div class="d-flex p-0 pb-2">
              <b-row>
                <b-col cols="12" class="text-left">
                  <h3 class="pl-3 pt-3">{{ $t("Account List") }}</h3>
                </b-col>
                <!-- <b-col cols="12" md="5" class="ml-auto text-right mb-3">
                                    <a href="account-opening" class="btn btn-primary ml-auto text-white mb-4 mt-3">+Create Account</a>
                                </b-col> -->
              </b-row>
            </div>
            <!-- <AccountTable @sub-account="createSubAccount"></AccountTable> -->
            <AccountList @viewDetail="viewDetail"></AccountList>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <b-modal
      id="modal-detail-subaccount"
      class="p-0"
      size="md"
      hide-footer
      hide-header-close
    >
      <img
        :src="`${publicPath}/img/gep/icon/details.svg`"
        width="100px"
        class="ml-auto mr-auto d-block details-icon"
      />
      <div class="text-center fz-16 fw-600 text-grey7 mb-1">
        {{ $t("Details") }}
      </div>
      <div class="text-center fz-28 fw-600 mb-4">
        {{ current_data.bankAccountName }}
      </div>
      <hr class="dashed" />
      <b-row>
        <b-col cols="12">
          <table class="table-rounded w-100">
            <tr>
              <td class="p-2 text-grey7 fw-500">{{ $t("Account Name") }}</td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ current_data.bankAccountName }}
              </td>
            </tr>
            <tr>
              <td class="p-2 text-grey7 fw-500">{{ $t("Bank Name") }}</td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ current_data.bankName }}
              </td>
            </tr>
            <tr>
              <td class="p-2 text-grey7 fw-500">{{ $t("Bank No") }}</td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ current_data.bankNo }}
              </td>
            </tr>
            <tr>
              <td class="p-2 text-grey7 fw-500">{{ $t("Bank Code") }}</td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ String(current_data.bankSubCode).split("-")[0] }}
              </td>
            </tr>
            <tr>
              <td class="p-2 text-grey7 fw-500">
                {{ $t("Bank Branch Code") }}
              </td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ String(current_data.bankSubCode).split("-")[1] }}
              </td>
            </tr>
            <tr>
              <td class="p-2 text-grey7 fw-500">{{ $t("Bank Address") }}</td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ current_data.bankAddress }}
              </td>
            </tr>
            <tr>
              <td class="p-2 text-grey7 fw-500">{{ $t("Swift Code") }}</td>
              <td class="px-3 text-center">:</td>
              <td class="px-3 fw-600 text-right" style="max-width: 220px">
                {{ current_data.swiftCode }}
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <hr class="dashed" />
      <button
        class="btn btn-primary mt-3 w-100"
        @click="$bvModal.hide('modal-detail-subaccount')"
      >
        {{ $t("Close") }}
      </button>
    </b-modal>
    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>
<script>
import LoaderComponent from "@/components/LoaderComponent";
import AccountTable from "@/components/AccountTable";
import AccountList from "@/components/AccountList";

import moment from "moment";

export default {
  name: "list-account",
  data() {
    return {
      publicPath: process.env.BASE_URL != "/" ? process.env.BASE_URL : "",
      isLoading: false,
      current_data: {},
    };
  },
  components: {
    LoaderComponent,
    AccountTable,
    AccountList,
  },
  methods: {
    viewDetail(sub_account) {
      console.log(sub_account);

      const parameter = {
        title: "Confirmation of RCPAY Limited Virtual Account Opening",
        "sub-title": `We confirm that the following virtual account has been established for our client, ${sub_account["bankAccountName"]}, with our banking partner, facilitated by RCPAY Limited.`,
        "table-title-account": "Account Information:",
        "table-title-banking": "Banking Details:",
        "params-account": JSON.stringify({
          "Beneficiary Name": sub_account["bankAccountName"],
          "Account Number": sub_account["bankNo"],
          "Account Type": "Virtual Account",
          "Account Currency": "Multi-Currency",
        }),
        "params-banking": JSON.stringify({
          "Bank Name": sub_account["bankName"],
          "SWIFT/BIC Code": sub_account["swiftCode"],
          "Bank Code": sub_account["bankCode"],
          "Branch Code": sub_account["bankSubCode"],
          "Bank Address": sub_account["bankAddress"],
        }),
        "footer-text":
          "This document serves as an official confirmation of the account details provided above",
      };

      const queryString = new URLSearchParams(parameter).toString();
      const url = `/document-account.html?${queryString}`;

      window.open(url, "_blank");
    },
    checkError(err) {
      try {
        this.isLoading = false;
        const response = err.response;
        if (response.status == 400) {
          console.log(response.data);
          if (typeof response.data.message === "string") {
            this.$notify({
              type: "warn",
              text: response.data.message,
            });
          } else {
            if (response.data.message["errorMsg"]) {
              this.$notify({
                type: "warn",
                text: response.data.message["errorMsg"],
              });
            } else {
              let ret = [];
              Object.keys(response.data.message).forEach((key) => {
                ret.push(response.data.message[key][0]);
              });

              this.$notify({
                type: "warn",
                html: ret.join("<br>"),
              });
            }
          }
        } else if (
          response.status == 401 &&
          response.data.name == "Unauthorized"
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("member");
          localStorage.removeItem("isFirstTime");
          this.$router.push({
            path: "/login",
          });
        } else {
          if (localStorage.getItem("token")) {
            var msg = response.data ? response.data.message : err.message;
            this.$notify({
              type: "warn",
              text: msg,
            });
          }
        }
      } catch (e) {
        console.log(err);
      }
    },
  },
  mounted() {},
};
</script>
